import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ApiRestService} from "../../_services/api-rest.service";
import {Destinazione} from "../../Models/destinazione";
import {CampoAggiuntivo} from "../../../shared/models/campo-aggiuntivo";
import {VoceProgetto} from "../../Models/VoceProgetto";
import { environment } from 'src/environments/environment';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {DestinazioniEditComponent} from "../destinazioni-edit/destinazioni-edit.component";
import {ToastrService} from "ngx-toastr";
import {Azienda} from "../../../Admin/models/Azienda";

@Component({
  selector: 'app-destinazioni-list',
  templateUrl: './destinazioni-list.component.html',
  styleUrls: ['./destinazioni-list.component.css']
})
export class DestinazioniListComponent implements OnInit {
  @Input()  projectId: number;
  @Output() projectIdChange = new EventEmitter();
  @Input()  clientObject: Azienda;
  @Output() clientObjectChange = new EventEmitter();
  @Input()  items: Destinazione[] = [];
  @Output() itemsChange = new EventEmitter<Destinazione[]>();

  @Input() title: string = 'Dettaglio';
  @Input() CampiAggiuntivi: CampoAggiuntivo[] = [];
  @Input() HasHeader: boolean = true;
  @Input() HasAddButton: boolean = true;
  @Input() externalAddFunction: boolean = false;
  @Input() HasEditButton: boolean = true;
  @Input() externalEditFunction: boolean = false;
  @Input() HasDeleteButton: boolean = true;
  @Input() externalDeleteFunction: boolean = false;
  @Input() HasDuplicaButton: boolean = false;
  @Input() externalDuplicaFunction: boolean = false;
  @Input() DisableEdit: boolean = false;
  @Input() inLineEdit: boolean = false;

  @Output() AddClicked = new EventEmitter();
  @Output() UpdateClicked = new EventEmitter<VoceProgetto>();
  @Output() DeleteClicked = new EventEmitter<VoceProgetto>();
  @Output() RestoreClicked = new EventEmitter<VoceProgetto>();
  @Output() OpenClicked = new EventEmitter<VoceProgetto>();
  @Output() DuplicaClicked = new EventEmitter();

  public environment = environment;
  constructor(
    private apiRest: ApiRestService,
    private modalService: NgbModal,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes && changes['projectId'] ) {
      var projectId = changes['projectId'].currentValue;
      console.log("Project Id: ",projectId);
      this.Refresh(projectId);
    }
    if(changes && changes['clientObject'] && changes['clientObject'].currentValue != changes['clientObject'].previousValue) {
      var clientObject = changes['clientObject'].currentValue;
      console.log("Client Object: ", clientObject);
    }
  }
  Refresh(projectId: number){
    if( !projectId ) return;
    this.apiRest.GetDestinazioniList({id: projectId}).subscribe(data=> this.items = data?.data ?? []);
  }

  Add() {
    if(this.externalAddFunction) {
      this.AddClicked.emit();
      return;
    } else
      if (this.projectId)
        this.openDetails(new Destinazione());
      else
        this.toastr.warning("E' necessario salvare prima di effettuare questa operazione", "Attenzione")
  }

  duplicaClick(item: Destinazione) {
    if(this.externalDuplicaFunction){
      this.DuplicaClicked.emit(item);
      return;
    } else
      this.apiRest.GetDestinazione(item).subscribe(data=>{
        this.apiRest.AddDestinazione(data).subscribe();
      })
  }

  delete(item: Destinazione) {
    if(this.externalDeleteFunction){
      this.DeleteClicked.emit(item);
      return;
    } else
      this.apiRest.DeleteDestinazione(item).subscribe(()=>{
        this.Refresh(this.projectId);
      });
  }

  edit(item: Destinazione) {
    if(this.externalEditFunction){
      this.UpdateClicked.emit(item);
      return;
    } else if(this.inLineEdit && !item.modifica)
      item.modifica = !item.modifica;
    else if(this.inLineEdit && item.modifica) {
      item.modifica = !item.modifica;
      this.apiRest.UpdateDestinazione(item).subscribe(() => {
        this.Refresh(this.projectId);
      })
    }else
      this.openDetails(item)
  }

  openDetails(destinazione: Destinazione){
    var destinazioneedit = this.modalService.open(DestinazioniEditComponent, {
      centered: true,
      backdrop: "static",
      size:'xl'
    });
    destinazione.progetto = this.projectId;
    (<DestinazioniEditComponent>destinazioneedit.componentInstance).Cliente = this.clientObject;
    (<DestinazioniEditComponent>destinazioneedit.componentInstance).item = destinazione;
    (<DestinazioniEditComponent>destinazioneedit.componentInstance).Refresh.subscribe(()=>{
      this.Refresh(this.projectId);
    })
  }
}
